<template>
  <div class="maxContainer">
    <div v-if="!EquipmentState" class="container">
      <div class="logo">
        <img
          src="https://taifuapp-website-ol.oss-cn-shanghai.aliyuncs.com/images/logo.png"
          alt=""
        />
      </div>
      <div class="rightLink">
        <router-link
          v-for="item in routerData"
          :to="item.path"
          activeClass="activeTitle"
          exactActiveClass="exactTitle"
        >
          {{ item.meta.title }}
          <span></span>
        </router-link>
      </div>
    </div>
    <div v-else-if="EquipmentState" class="appContainer">
      <div class="logo">
        <img
          src="https://taifuapp-website-ol.oss-cn-shanghai.aliyuncs.com/images/logo.png"
          alt=""
        />
      </div>
      <img
        src="https://taifuapp-website-ol.oss-cn-shanghai.aliyuncs.com/images/icon05.png"
        alt=""
        class="menuIcon"
        @click="changeMenu"
      />
      <div class="rightLinkBox" v-if="menuState">
        <i></i>
        <div class="appRightLink">
          <router-link
            v-for="item in routerData"
            :to="item.path"
            activeClass="activeTitle"
            exactActiveClass="exactTitle"
          >
            {{ item.meta.title }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getEquipment from "@/mixins/getEquipment";
export default {
  name: "TagsViews",
  mixins: [getEquipment],
  data() {
    return {
      routerData: null,
      menuState: false,
    };
  },
  mounted() {
    this.initRouterData();
  },
  methods: {
    initRouterData() {
      this.routerData = this.$router.options.routes;
      this.routerData.forEach((item) => {
        if (item.name === "home") {
          this.routerData = item.children;
        }
      });
    },
    changeMenu() {
      this.menuState = !this.menuState;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  border-bottom: 1px solid #ffffff;
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  z-index: 2000;
  align-items: center;
  justify-content: space-between;
  .logo {
    margin-left: 50px;
    img {
      height: 50px;
    }
  }
  .rightLink {
    margin-right: 40px;
    display: flex;
    align-items: center;
    height: 100%;
    a {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      margin-left: 110px;
      font-size: 14px;
      transition: all 0.2s;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      line-height: 60px;
      letter-spacing: 2px;
      position: relative;
      opacity: 0.8;
    }
    .activeTitle {
      font-size: 16px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #ffffff;
      transition: all 0.2s;
      opacity: 1;
      span {
        width: 100%;
      }
    }
    span {
      display: inline-block;
      width: 0;
      transition: all 0.2s;
      height: 4px;
      background: #eb9b6a;
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
    a:hover span {
      width: 100%;
      transition: all 0.2s;
    }
    .exactTitle {
    }
  }
}
.appContainer {
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  z-index: 2000;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  .logo {
    img {
      height: 36px;
    }
  }
  .menuIcon {
    width: 18px;
    height: 18px;
  }
  .rightLinkBox {
    position: absolute;
    top: 60px;
    right: 15px;
    width: 88px;
    border-radius: 4px;
    background: #ffffff;
    box-shadow: 0 0 11px 0 rgba(5, 19, 48, 0.14);
    i {
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #ffffff;
      position: absolute;
      top: -4px;
      right: 4px;
    }
    .appRightLink {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      z-index: 2;
      a {
        display: inline-block;
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 45px;
      }
      a:not(:last-child) {
        border-bottom: 1px solid rgba(5, 19, 48, 0.14);
      }
      .activeTitle {
        background: rgba(235, 155, 106, 0.1);
        color: #eb9b6a;
      }
    }
  }
}
</style>
